












































































































































































































import {Vue, Component, Ref, Watch} from 'vue-property-decorator';
import {SelectWings, Througoutput, InputWings } from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {AccountItem, AccountItemImpl} from "@/store/accounts/types";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import { ActionLog } from '@/store/auth/types';
import { getTranslatedParams } from '@/utils/notify-utils';

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {SelectWings, Througoutput, InputWings}})
export default class Account extends Vue {
  @Ref('validator') validator: any;
  @Getter("transports") transportsList: any;
  @Getter("protocolList") protocolList: any;

  @Action("getTransports") actionGetTransports: any;
  @Action("getAccountItem") actionGetItem: any;
  @Action("saveAccount") actionSave: any;
  @Action("deleteAccount") actionDelete: any;
  @Action("actionLog") actionLog: any;

  item = this.defaultItem();
  itemSaved = this.defaultItem();
  logObject: ActionLog = {};
  additional_processing = 0;

  defaultItem(): AccountItem {
    return new AccountItemImpl()
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Viewing",
          actionStatus: "success",
          objectType: "Account",
        }
        const data = await this.actionGetItem(this.$route.params.id)
        this.logObject.objectName = data.login;
        await this.actionLog(this.logObject);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(this.item);
        this.additional_processing = this.item.additional_processing_rule ? 1 : 0
      } catch(error) {
        this.actionLog({...this.logObject, actionStatus: "failed"});
        notifyError(error);
        this.back();
      }
    }
    this.actionGetTransports();
  }

  back(): void {
    this.$router.push('/accounts/');
  }

  async onSaveItem(): Promise<void> {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return
    }
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: this.$route.params.id ? "Editing" : "Creation",
        actionStatus: "success",
        objectType: "Account",
        objectName : this.item.login,
        addititionalInfo: getTranslatedParams(this.item)
      }
      await this.actionSave(this.item);
      await this.actionLog(this.logObject);
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      await this.actionLog({...this.logObject, actionStatus: "failed"});
      notifyError(error);
    }
  }

  async onDeleteItem(): Promise<void> {
    if (!await notifyDelete()) {
      return
    }
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Removal",
        actionStatus: "success",
        objectType: "Account",
        objectName : this.item.login,
        addititionalInfo: getTranslatedParams({id: this.item.id})
      }
      await this.actionDelete(this.item)
      await this.actionLog(this.logObject)
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: "failed"});
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  onInputPassword(event:any) {
    this.item.password = event
    this.$emit('input', event)
  }

  onInputConfirmPassword(event:any) {
    this.item.confirm_password = event
    this.$emit('input', event)
  }

  @Watch('item.protocol_id', { immediate: true })
  onChangeProtocolId(val:number, oldVal?: number){
    if (oldVal && val === 1) {
      this.item.additional_processing_rule = null
      this.item.transport = null
      this.item.transport_id = null
      this.item.max_throughput = ''
      this.item.immediate_response_needed = 1
    }
    if (oldVal && val === 2) {
      this.item.push_statuses = 0
      this.item.url = null
      this.item.status_report = 0
      this.item.max_throughput = '10/1000'
    }
  }

  @Watch('additional_processing')
  onChangeAdditionalProcessing(val: number) {
    if (val === 1) {
      this.item.transport_id = null
      this.item.transport = null
    }
    if (val === 0 || val === null) {
      this.item.additional_processing_rule = null
    }
    this.$nextTick(() => this.validator?.reset?.())
  }

  get transportsForAccounts() {
    return this.transportsList
  }

  get status():number {
    return this.item.status
  }

  set status(value:number) {
    this.item.status = (value ?? 0)
  }

  get push_statuses():number {
    return this.item.push_statuses || 0
  }

  set push_statuses(value:number) {
    if (value!==1) {
      this.item.url = undefined
    }
    this.item.push_statuses = (value ?? 0)
  }

  get immediate_response_needed():number {
    return this.item.immediate_response_needed || 0
  }

  set immediate_response_needed(value:number) {
    this.item.immediate_response_needed = (value ?? 0)
  }
}
